import classNames from 'classnames';
import { createContext, useCallback, useContext, useEffect, useRef, useState, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { useIsWideMainLayout } from '../main_region';
import { setStickyFooterVisible } from '../slice';
const stickyWrapperCss = "s1eh03ca";
const StickyWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stickyWrapperCss, props.className)} />;
});
const stickyFooterContentIsWideCss = "s1sfawm9";
const stickyFooterContentCss = "s8mcmo1";
const StickyFooterContent = forwardRef((props, ref) => {
  const {
    isWide,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stickyFooterContentCss, {
    [stickyFooterContentIsWideCss]: isWide
  }, props.className)} />;
});
const Context = createContext({
  isPortalRendered: false,
  portalRef: null
});
const {
  Provider
} = Context;
export const StickyFooterContext = ({
  children
}) => {
  const portalRef = useRef();
  const [portalRendered, setPortalRendered] = useState(false);
  const [refBound, setRefBound] = useState(false);
  const callbackRef = useCallback(ref => {
    portalRef.current = ref;
    setRefBound(!!ref);
  }, []);
  return <Provider value={{
    bindRef: callbackRef,
    portalRef,
    portalRendered,
    setPortalRendered,
    refBound
  }}>
      {children}
    </Provider>;
};
const useStickyFooterContext = () => useContext(Context);
export const StickyFooter = ({
  children
}) => {
  const dispatch = useDispatch();
  const {
    portalRef,
    refBound,
    setPortalRendered
  } = useStickyFooterContext();
  useEffect(() => {
    dispatch(setStickyFooterVisible(true));
    setPortalRendered(true);
    return () => {
      dispatch(setStickyFooterVisible(false));
      setPortalRendered(false);
    };
  }, [dispatch, setPortalRendered]);
  if (!refBound) return null;
  return createPortal(children, portalRef.current);
};
export const StickyFooterOutlet = () => {
  const {
    bindRef,
    portalRendered
  } = useStickyFooterContext();
  const [isWide] = useIsWideMainLayout();
  if (!portalRendered) return null;
  return <StickyWrapper data-component="sticky-footer">
      <StickyFooterContent ref={bindRef} isWide={isWide} />
    </StickyWrapper>;
};

require("./sticky_footer.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./sticky_footer.js");